import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches saved payment methods for a member from Stripe. */
export function useListMemberPaymentMethods(memberId: string) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['member-payment-methods', memberId],
    queryFn: async () => {
      const response = await api.get('/members/:memberId/payment-methods', { params: { memberId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.paymentMethods
    },
  })
}
